const LicenseDataMapper = {
  toDataPage: data => ({
    email: data.Email,
    externalUserId: data.ExternalUserId,
    firstName: data.FirstName,
    lastName: data.LastName,
    ohtIds: data.AllowedOhtIds,
    orgIds: data.AllowedOrgIds,
    orgUnitIds: data.AllowedOrgUnitIds,
    roleId: data.SystemRole.Id,
    supplementalRoleId: data.SupplementalRoleId,
    superUser: data.IsSuperUser,
    isAppraiser: data.IsAppraiser,
    isDeactivated: data.IsDeactivated,
    canAccessInvoices: data.CanAccessInvoices
  }),
  licenseDataToApolloInput: (
    userData,
    orgId,
    orgUnitId,
    permissionData,
    customPermissionData,
    isUserAbleToSetSuperUserCheckbox,
    isUserAbleToSetViewInvoicesCheckbox
  ) => ({
    ExternalUserId: userData.externalUserId,
    Email: userData.email.trim(),
    FirstName: userData.firstName.trim(),
    LastName: userData.lastName.trim(),
    SystemRoleId: userData.selectedRole,
    LicensedOrgId: orgId,
    LicensedOrgUnitId: orgUnitId,
    AllowedOrgIds: permissionData.orgIds,
    AllowedOrgUnitIds: permissionData.orgUnitIds,
    AllowedOhtIds: permissionData.ohts,
    IsSuperUser: isUserAbleToSetSuperUserCheckbox ? customPermissionData.superUser : null,
    CanAccessInvoices: isUserAbleToSetViewInvoicesCheckbox
      ? customPermissionData.canAccessInvoices
      : null
  })
};

export default LicenseDataMapper;
